import { render, staticRenderFns } from "./PersonForm.vue?vue&type=template&id=14ec61c2&"
import script from "./PersonForm.vue?vue&type=script&lang=js&"
export * from "./PersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14ec61c2')) {
      api.createRecord('14ec61c2', component.options)
    } else {
      api.reload('14ec61c2', component.options)
    }
    module.hot.accept("./PersonForm.vue?vue&type=template&id=14ec61c2&", function () {
      api.rerender('14ec61c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/Person/modules/PersonForm.vue"
export default component.exports